export const DDEX_ROUTES = {
  ROOT: '/',

  DDEX_LIST: '/release/ddex',
  DDEX_RELEASE_DETAILS: (id: string) => `/release/settings/core-details/${id}`,
} as const;
